import { FORM_TYPES } from "services/sosInventoryService/formTemplate/schema";

export function afterGet(record) {
  const newRecord = { ...record };
  newRecord.form = FORM_TYPES.find(({ id }) => id === record.form) || null;
  return newRecord;
}
